/** @format */

// Whether a select's control is a text box you can type into:
//
//   true               type to filter the list
//   false              a plain dropdown
//   'above-threshold'  plain until the list is longer than SEARCHABLE_ABOVE
//
// react-select's own isSearchable, widened by the third.

export type Searchable = boolean | 'above-threshold'

// Above this many options, filtering beats scanning.
export const SEARCHABLE_ABOVE = 5

/** Undefined where the caller said nothing, leaving react-select its default. */
export function resolveSearchable(
  searchable: Searchable | undefined,
  optionCount: number,
  threshold: number = SEARCHABLE_ABOVE,
): boolean | undefined {
  return searchable === 'above-threshold' ? optionCount > threshold : searchable
}
